module.exports = __webpack_public_path__ + "static/media/homeBK.312f0cc2.gif";